import { get } from 'utils/api';

export const getChargerLogGraphById = (id) => {
  return get(`/charger_logs/measurandOfChargerLogs/${id}`);
};

export const chargerLogGraph = {
  getChargerLogGraphById,
};
